import { swalAlertError, swalSuccessGeneral } from './swalAlert'

export const downloadCSV = async (entity, response) => {
  try {
    // Verificar si la respuesta contiene datos
    if (response && (response.payload || response.data || response)) {
      // Determinar qué datos usar
      const csvData = response.payload || response.data || response
      console.log('csvData', csvData)
      // Crear un blob con el contenido CSV
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })

      // Crear un enlace temporal para la descarga
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)

      link.setAttribute('href', url)
      link.setAttribute(
        'download',
        `${entity}_${new Date().toISOString().split('T')[0]}.csv`,
      )
      link.setAttribute('style', 'visibility: hidden')

      // Añadir al DOM, hacer clic y remover
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      // Limpiar la URL del objeto
      URL.revokeObjectURL(url)

      swalSuccessGeneral(
        'Exportación completada',
        'El archivo CSV se ha descargado correctamente',
      )
    } else {
      console.error('No se recibieron datos del servidor')
      swalAlertError('No se recibieron datos del servidor para generar el CSV')
    }
  } catch (error) {
    console.error('Error al exportar CSV:', error)
    swalAlertError('Error al generar el archivo CSV')
  }
}
